function noop() {}
export var defaultProps = {
    prefixCls: 'am-search',
    placeholder: '',
    onSubmit: noop,
    onChange: noop,
    onFocus: noop,
    onBlur: noop,
    onClear: noop,
    showCancelButton: false,
    disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/search-bar/PropsType.js
// module id = 1905
// module chunks = 0